var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _circle7, _circle8, _circle9, _circle10, _path6, _path7, _circle11, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotifSession2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 715,
    viewBox: "0 0 390 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 0 0 1 357.5 422.5)",
    fill: "#143162"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 0 0 1 357.5 487.5)",
    fill: "#0052A4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 0 0 1 357.5 617.499)",
    fill: "#0052A4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 0 0 1 292.5 552.5)",
    fill: "#66DDC0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5.41666,
    transform: "matrix(-1 0 0 1 292.5 617.499)",
    fill: "#66DDC0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5.41666,
    transform: "matrix(-1 0 0 1 124.583 422.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.5 455C310.449 455 325 440.449 325 422.5C325 404.55 310.449 390 292.5 390L227.5 390C209.551 390 195 404.55 195 422.5C195 440.449 209.551 455 227.5 455L292.5 455Z",
    fill: "#66DDC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 649.999C115.449 649.999 130 635.449 130 617.499C130 599.55 115.449 585 97.5 585L32.5001 584.999C14.5508 584.999 0.000109017 599.55 0.000108232 617.499C0.000107448 635.449 14.5508 649.999 32.5001 649.999L97.5 649.999Z",
    fill: "#66DDC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5 714.999C375.449 714.999 390 700.449 390 682.499C390 664.55 375.449 649.999 357.5 649.999L292.5 649.999C274.551 649.999 260 664.55 260 682.499C260 700.449 274.551 714.999 292.5 714.999L357.5 714.999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 552.5C195 570.449 209.551 585 227.5 585C245.449 585 260 570.449 260 552.5L260 487.5C260 469.55 245.449 455 227.5 455C209.551 455 195 469.55 195 487.5L195 552.5Z",
    fill: "#143162"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195 520L260 520L260 487.5C260 469.55 245.449 455 227.5 455C209.551 455 195 469.55 195 487.5L195 520Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 357.5 32.5)",
    fill: "#143162"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 357.5 97.4999)",
    fill: "#0052A4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 357.5 227.5)",
    fill: "#0052A4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 292.5 162.5)",
    fill: "#66DDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.5 64.9999C310.449 64.9999 325 50.4492 325 32.5C325 14.5507 310.449 -6.99336e-06 292.5 -6.20878e-06L227.5 -3.36754e-06C209.551 -2.58295e-06 195 14.5507 195 32.5C195 50.4492 209.551 64.9999 227.5 64.9999L292.5 64.9999Z",
    fill: "#66DDC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5 325C375.449 325 390 310.449 390 292.5C390 274.551 375.449 260 357.5 260L292.5 260C274.551 260 260 274.551 260 292.5C260 310.449 274.551 325 292.5 325L357.5 325Z",
    fill: "#DDE2E9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 162.5 292.5)",
    fill: "#0052A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195 162.5C195 180.449 209.551 195 227.5 195C245.449 195 260 180.449 260 162.5V97.4999C260 79.5507 245.449 65 227.5 65C209.551 65 195 79.5507 195 97.4999V162.5Z",
    fill: "#143162"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195 130H260V97.4999C260 79.5506 245.449 64.9999 227.5 64.9999C209.551 64.9999 195 79.5507 195 97.4999V130Z",
    fill: "#DDE2E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifSession2);
export default __webpack_public_path__ + "static/media/motif-session-2.3611da3a0fc3ae53ba11576485084465.svg";
export { ForwardRef as ReactComponent };